import { Empty, Select } from 'antd'
import _ from 'lodash'
import React from 'react'
import { app } from 'xadmin'
import { Icon } from 'xadmin-ui'
import NoData from './../../../components/NoData'

const { Option } = Select


const TypeSelect = props => {
  const { input: { onChange, value }, field, field: { key, option: { form } } } = props
  const { settings: { nodeconfig } } = app.context.store.getState()
  const types = nodeconfig && nodeconfig.nodekind || []
  const [{ loading, options }, setState] = React.useState({ loading: false, options: types })

  const onSelectChange = (select) => {
    const val = _.find(options, opt => opt.id == select)
    if (val) {
      onChange(val.id || {})
      form.change('kindName', val.name || '')
    } else {
      onChange(null)
      form.change('kindName', null)
    }
  }

  const ops = (options || []).map(option => { return { label: option.name, value: option.id, item: option } })
  let values = []
  if (value) {
    const val = _.find(options, opt => opt.id == value)
    values = val && val.name || []
  }
  return (
    <Select value={values || undefined} allowClear isLoading={loading} placeholder="请选择"
      notFoundContent={loading ?
        <Icon type="loading" style={{ width: 14, display: 'block', margin: '0 auto' }} /> :
        <NoData />
      }
      style={{ minWidth: 100, width: 200 }}
      onChange={onSelectChange}
      {...field.attrs}
    >
      {ops.map(item => (<Option value={item.value} key={item.value}>{item.label}</Option>))}
    </Select>
  )
}

export default TypeSelect

